export default __webpack_public_path__ + "static/media/Casa_di_pan_di_Zenzero.23671cd1.jpg";